import { ADMIN_ROLE_SLUG, FFL_ROLE_SLUG } from 'config/app.config';

import { getUserCurrentRole, getUserInfo } from './StorageHelper';

const OTHER_PERMISSION_SLUG = 'other';
export const permissionSlugs = {
  dashboard: OTHER_PERMISSION_SLUG,
  // employee
  create_employee: 'employee.create',
  employee_list: 'employee.list',
  edit_employee: 'employee.edit',
  delete_employee: 'employee.delete',
  export_employee: 'employee.export',
  // role
  create_role: 'role.create',
  role_list: 'role.list',
  edit_role: 'role.edit',
  delete_role: 'role.delete',
  export_role: 'role.export',
  // customer
  customer_list: 'customer.list',
  edit_customer: 'customer.edit',
  delete_customer: 'customer.delete',
  export_customer: 'customer.export',
  // customer group
  create_customer_group: 'customer.group.create',
  customer_group_list: 'customer.group.list',
  edit_customer_group: 'customer.group.edit',
  delete_customer_group: 'customer.group.delete',
  export_customer_group: 'customer.group.export',
  // ffl
  ffl_list: 'ffl.list',
  edit_ffl: 'ffl.edit',
  ffl_detail: 'ffl.details',
  delete_ffl: 'ffl.delete',
  export_ffl: 'ffl.export',
  //product category
  product_category_list: 'product.category.list',
  create_product_category: 'product.category.create',
  edit_product_category: 'product.category.edit',
  delete_product_category: 'product.category.delete',
  export_product_category: 'product.category.export',
  // product
  product_list: 'product.list',
  create_product: 'product.create',
  edit_product: 'product.edit',
  product_detail: 'product.details',
  delete_product: 'product.delete',
  export_product: 'product.export',
  import_product: 'product.import',
  // order
  order_list: 'order.list',
  order_detail: 'order.details',
  // transaction
  transaction_list: 'transaction.list',
  transaction_detail: 'transaction.details',
  export_transaction: 'transaction.export',
  // search terms
  search_terms_list: 'search.terms.list',
  // support / reports
  order_report_list: 'order.report.list',
  integration_request_list: 'integration.request.list',
  export_search_terms: 'search.terms.export',
  // sms log
  sms_log_list: 'sms.log.list',
  export_sms_log: 'sms.log.export',
  // sms template
  // sms_template_list: 'other',
  // edit_sms_templates: 'other',
  sms_template_list: 'sms.template.list',
  edit_sms_templates: 'sms.template.edit',
  // review
  review_list: 'review.list',
  edit_review: 'review.edit',
  export_review: 'review.export',

  // review
  product_review_list: 'product.review.list',
  product_edit_review: 'product.review.edit',
  product_export_review: 'product.review.export',
  // message
  message_list: 'message.list',
  send_message: 'message.create',
  message_detail: 'message.details',
  export_message: 'message.export',
  // email template
  email_template_list: 'email.template.list',
  edit_email_templates: 'email.template.edit',
  // subscription plan
  subscription_plan_list: 'subscription.plan.list',
  create_subscription_plan: 'subscription.plan.create',
  edit_subscription_plan: 'subscription.plan.edit',
  subscription_plan_detail: 'subscription.plan.details',
  delete_subscription_plan: 'subscription.plan.delete',
  export_subscription_plan: 'subscription.plan.export',
  // blog
  blog_list: 'blog.list',
  create_blog: 'blog.create',
  edit_blog: 'blog.edit',
  blog_detail: 'blog.details',
  delete_blog: 'blog.delete',
  export_blog: 'blog.export',
  // blog category
  blog_category_list: 'blog.category.list',
  create_blog_category: 'blog.category.create',
  edit_blog_category: 'blog.category.edit',
  delete_blog_category: 'blog.category.delete',
  export_blog_category: 'blog.category.export',
  // editor demo
  editor_demo: 'editor.demo',
  // product attributes
  product_attribute_list: 'product.attribute.list',
  create_product_attribute: 'product.attribute.create',
  edit_product_attribute: 'product.attribute.edit',
  product_attribute_detail: 'product.attribute.details',
  delete_product_attribute: 'product.attribute.delete',
  export_product_attribute: 'product.attribute.export',
  // advertisement
  advertisement_list: 'advertisement.list',
  create_advertisement: 'advertisement.create',
  edit_advertisement: 'advertisement.edit',
  delete_advertisement: 'advertisement.delete',
  advertisement_detail: 'advertisement.detail',
  export_advertisement: 'advertisement.export',
  // content page
  content_page_list: 'content.page.list',
  create_content_page: 'content.page.create',
  edit_content_page: 'content.page.edit',
  content_page_detail: 'content.page.details',
  delete_content_page: 'content.page.delete',
  export_content_page: 'content.page.export',
  // advertisement location
  advertisement_location_list: 'advertisement.location.list',
  edit_advertisement_location: 'advertisement.location.edit',
  delete_advertisement_location: 'advertisement.location.delete',
  advertisement_location_detail: 'advertisement.location.detail',
  export_advertisement_location: 'advertisement.location.export',
  // guns for sale
  active_gun_list: 'active.gun.list',
  export_active_gun: 'active.gun.export',
  active_gun_detail: 'active.gun.details',
  edit_active_gun: 'active.gun.edit',
  // sold guns
  sold_gun_list: 'sold.gun.list',
  export_sold_gun: 'sold.gun.export',
  sold_gun_detail: 'sold.gun.details',
  edit_sold_gun: 'sold.gun.edit',

  //purchase forms
  purchase_forms_list: 'purchase.forms.list',
  purchase_forms_detail: 'purchase.forms.detail',
  export_purchase_forms: 'purchase.forms.export',

  //gun for sale
  gun_list: 'gun.list',
  export_gun: 'gun.export',
  gun_detail: 'gun.details',
  edit_gun: 'gun.edit',
  //Affiliate Analytics
  affiliate_analysis_list: 'affiliate.analysis.list',
  export_affiliate_analysis: 'affiliate.analysis.export',
  //Affiliate Code
  affiliate_code_list: 'affiliate.list',
  create_affiliate_code: 'affiliate.create',
  edit_affiliate_code: 'affiliate.edit',
  affiliate_code_detail: 'affiliate.details',
  delete_affiliate_code: 'affiliate.delete',
  export_affiliate_code: 'affiliate.export',
  //URL Rewrite
  // url_rewrite_list: 'other',
  // create_url_rewrite: 'other',
  // edit_url_rewrite: 'other',
  // delete_url_rewrite: 'other',
  // export_url_rewrite: 'other',
  url_rewrite_list: 'url.rewrite.list',
  create_url_rewrite: 'url.rewrite.create',
  edit_url_rewrite: 'url.rewrite.edit',
  delete_url_rewrite: 'url.rewrite.delete',
  export_url_rewrite: 'url.rewrite.export',

  // coupon
  create_coupon: 'coupon.create',
  coupon_list: 'coupon.list',
  export_coupon: 'coupon.export',
  coupon_detail: 'coupon.details',
  edit_coupon: 'coupon.edit',
  delete_coupon: 'coupon.delete',

  // General Setting
  general_setting: 'setting.general.list',
  edit_general_setting: 'setting.general.edit',
  create_general_setting: 'setting.general.create',
  export_general_setting: 'setting.general.create',

  // coupon
  transfer_list: 'transfer.list',
  export_transfer: 'transfer.export',
  transfer_detail: 'transfer.details',
  edit_transfer: 'transfer.edit',

  //banner
  banner_list: 'banner.list',
  create_banner: 'banner.create',
  edit_banner: 'banner.edit',
  delete_banner: 'banner.delete',
  export_banner: 'banner.export',

  //manufacturer
  manufacturer_list: 'manufacturer.list',
  create_manufacturer: 'manufacturer.create',
  edit_manufacturer: 'manufacturer.edit',
  delete_manufacturer: 'manufacturer.delete',
  export_manufacturer: 'manufacturer.export',
  // faq
  faq_list: 'faq.list',
  add_faq: 'faq.create',
  edit_faq: 'faq.edit',
  delete_faq: 'faq.delete',
  export_faq: 'faq.export',

  //

  dynamic_module_list: 'dynamic.module.list',
  edit_dynamic_module: 'dynamic.module.edit',
  delete_dynamic_module: 'dynamic.module.delete',
  export_dynamic_module: 'dynamic.module.export',
};

// Who gets the separate Merchandise page: the platform admin, or an FFL whose record has
// allow_merchandise on (read from the FFL profile saved at login).
export const canManageMerchandise = () => {
  const roleSlug = getUserCurrentRole()?.slug;
  if (roleSlug === ADMIN_ROLE_SLUG) return true;
  const userInfo: any = getUserInfo();
  return roleSlug === FFL_ROLE_SLUG && userInfo?.fflInfo?.allow_merchandise === true;
};

export const hasUserAccessFunctionality = (functionalityName: any) => {
  const hasPermission = checkUserPermissionList(functionalityName);
  return hasPermission;
};
export const checkUserPermissionList = (functionalityList: any) => {
  if (!functionalityList || !Array.isArray(functionalityList)) return false;
  const userRolePermission = (getUserCurrentRole()?.role_permissions as string[]) ?? [];
  const permissionList = [...userRolePermission, permissionSlugs.dashboard, OTHER_PERMISSION_SLUG];
  permissionList.push(permissionSlugs.dashboard);
  permissionList.push(OTHER_PERMISSION_SLUG);
  const hasPermission = permissionList.some((path: string) => functionalityList.includes(path));
  return hasPermission;
};
